import { Box, CircularProgress } from '@mui/material'
import styled from '@emotion/styled'

import type { LoadingGridProps } from './types'

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
`

export const Loading = styled(CircularProgress)<Pick<LoadingGridProps, 'colorType'>>`
  color: ${({ colorType }) => (colorType === 'outline' ? 'rgba(40, 56, 151, 0.6)' : 'rgba(255, 255, 255, 0.6)')};

  .MuiCircularProgress-track {
    color: ${({ colorType }) => (colorType === 'outline' ? '#1a1c56' : 'rgb(255, 255, 255)')};
  }
`

export const LoadingText = styled(Box)`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.secondary};
`
